module.exports = __webpack_public_path__ + "img/pc_03.21818c8e.png";